<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex grow>
        <h1>{{ $t("tasksPage.title") }}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout row wrap pb-3>
      <v-flex shrink>
        <v-btn @click="createNewTask" color="primary" class="pl-2" outlined>
          <v-icon color="primary">add</v-icon>{{ $t("tasksPage.addTaskBtn") }}
        </v-btn>
      </v-flex>

      <v-flex shrink pl-5 pr-0>
        <v-divider vertical />
      </v-flex>

      <v-flex shrink>
        <v-btn
          @click="currentFilter = null"
          color="primary"
          text
          :disabled="!currentFilter"
          >{{ $t("tasksPage.filter.all") }}</v-btn
        >
      </v-flex>

      <v-flex shrink tasks__filter>
        <v-btn
          @click="currentFilter = 10"
          color="success"
          :depressed="currentFilter === 10"
          :outlined="currentFilter !== 10"
          >{{ $t("tasksPage.filter.new") }}</v-btn
        >
      </v-flex>
      <v-flex shrink tasks__filter>
        <v-btn
          @click="currentFilter = 20"
          color="warning"
          :depressed="currentFilter === 20"
          :outlined="currentFilter !== 20"
          >{{ $t("tasksPage.filter.inWork") }}</v-btn
        >
      </v-flex>
      <v-flex shrink tasks__filter>
        <v-btn
          @click="currentFilter = 30"
          color="primary"
          :depressed="currentFilter === 30"
          :outlined="currentFilter !== 30"
          >{{ $t("tasksPage.filter.complete") }}</v-btn
        >
      </v-flex>
      <v-flex shrink tasks__filter>
        <v-btn
          @click="currentFilter = 40"
          color="error"
          :depressed="currentFilter === 40"
          :outlined="currentFilter !== 40"
          >{{ $t("tasksPage.filter.canceled") }}</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12>
        <FullCalendar
          defaultView="dayGridMonth"
          :plugins="calendarPlugins"
          ref="fullCalendar"
          :header="{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
          }"
          :events="outputEvents"
          @dateClick="handleDateClick"
          @eventClick="handleEventClick"
          @datesRender="rerender"
          :selectable="true"
          :locale="langFullCalendar"
          :locales="allLocales"
        />
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="createTask"
      transition="slide-x-reverse-transition"
      content-class="halfscreen"
      persistent
    >
      <add-task
        v-on:addTask="addTask"
        v-on:closeModal="closeModal"
        v-on:closeModalAndUpdate="closeModalAndUpdate"
        :edited-task="task"
        :editMode="true"
        :isCreate="isCreate"
        v-if="task"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
// import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import allLocales from '@fullcalendar/core/locales-all';
//import ruLocale from "@fullcalendar/core/locales/ru";

import AddTask from "@/components/tasks/add";
import i18n from "@/services/i18n";

export default {
  name: "Tasks",
  components: { FullCalendar, AddTask },
  data: () => ({
    isLoaded: false,
    selectedEvent: {},
    notifications: null,
    newNotifications: [],
    recalls: null,
    startDate: null,
    endDate: null,
    count: 0,
    isLoading: false,
    allLocales,
    newEvents: [],
    currentView: null,
    currentFilter: null,
    isLocked: false,
    showDate: new Date(),
    calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    createTask: false,
    tasks: null,
    task: null,
    isCreate: null,
  }),
  computed: {
    getLang(){
        return i18n.locale
    },
    langFullCalendar(){
        // if(this.getLang == "ru")
        //     return this.ruLocale;
        // if(this.getLang == "vt")
        //     return this.viLocale;
        // return this.enLocale;
        return this.getLang;
    },
    outputEvents() {
      if (!this.newEvents || !this.newEvents.length) return [];
      if (!this.currentFilter) {
        return this.newEvents;
      }
      return this.newEvents.filter(
        (event) => event.status === this.currentFilter
      );
    },
  },
  methods: {
    rerender(e) {
      const date_from = new Date(e.view.activeStart)
        .toISOString()
        .substr(0, 10);

      const date_to = new Date(e.view.activeEnd).toISOString().substr(0, 10);

      const params = {
        date_from,
        date_to,
      };

      this.currentView = e.view;
      this.startDate = date_from;
      this.endDate = date_to;

      this.getTasks(params);
    },
    async getTasks(params) {
      this.tasks = [];
      const url = "v1/task";

      await apiCallTrue({ url, params })
        .then((response) => {
          this.tasks =
            response && response.data && response.data.data
              ? response.data.data
              : [];

          this.prepareEvents();
        })
        .catch((error) => console.log("ERROR", error));

      // if (!this.isLocked && params.date_from && params.date_to) {
      //     this.isLocked = true;

      //     // this.isLoading = false;

      //     // console.log(
      //     //     "start get tasks",
      //     //     this.startDate === params.date_from,
      //     //     this.endDate === params.date_to,
      //     //     params
      //     // );

      //     this.tasks = [];
      //     // this.newEvents = [];
      //     const url = "v1/task/get-responsible";

      //     await apiCallTrue({ url })
      //         .then(response => {
      //             // console.log("get tasks response", response);
      //             this.tasks =
      //                 response && response.data && response.data.data
      //                     ? response.data.data
      //                     : [];

      //             // this.prepareEvents();
      //         })
      //         .catch(error => console.log("ERROR", error));
      // }
    },
    prepareEvents() {
      this.newEvents = [];
      this.tasks.map((task) => {
        const endDate = new Date(
          new Date(task.date_end).getTime() + 1000 * 3600
        );

        const newEvent = {
          id: task.id,
          status: task.status,
          start: new Date(task.date_start),
          end: endDate,
          title: task.name,
          classNames: ["custom-class", `status__${task.status}`],
        };
        this.newEvents.push(newEvent);
      });
      this.isLoaded = true;
      this.isLoading = false;

      this.isLocked = false;
    },
    handleDateClick(arg) {
      this.isCreate = false;
      this.task = { date_start: arg.dateStr, date_end: arg.dateStr };
      this.createTask = true;
    },
    createNewTask() {
      const today = new Date().toISOString().substr(0, 10);
      this.isCreate = true;
      this.task = { date_start: today, date_end: today };
      this.createTask = true;
    },
    closeModal() {
      this.task = null;
      this.isCreate = null;
      this.createTask = false;
    },
    addTask(task) {
      console.log("in add task", task);
      this.createTask = false;
      this.task = null;
      this.isCreate = null;
    },
    closeModalAndUpdate() {
      this.closeModal();
      const params = {
        date_from: this.startDate,
        date_to: this.endDate,
      };
      this.getTasks(params);
    },
    async deleteEntry(item) {
      const index = this.tasks.indexOf(item);

      await apiCallTrue({
        url: `v1/task/${item.id}/delete`,
        method: "POST",
      })
        .then(() => {
          this.tasks.splice(index, 1);
        })
        .catch(() => console.log("not deleted"));
    },
    handleEventClick(e) {
      const id = e.event.id;
      this.$router.push(`/tasks/${id}`);
    },
  },

  mounted() {
    // this.getRecalls();
  },
};
</script>
<style lang="scss" scoped>
.notifications {
  &__item {
    transition: opacity 0.3s ease;

    &--archive {
      opacity: 0.4;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";

.fc-button-primary:focus {
  outline: none !important;
  box-shadow: 0 0 0 !important;
}
.fc-button-primary {
  color: #404ce6;
  background-color: transparent;
  border-color: #404ce6;
  transition: all 0.3s ease;
}
.fc-button-primary:hover {
  color: #404ce6;
  background-color: #dcddf3;
  border-color: #404ce6;
}
.fc-button-primary:not(:disabled):active,
.fc-button-primary:not(:disabled).fc-button-active {
  color: #fff;
  background-color: #404ce6;
  border-color: #404ce6;
}

.custom-class {
  // background-color: #00a65a;
  // border-color: #00a65a;
}
.fc-event-container .fc-event {
  color: #fff;
}

.fc-event {
  &.status {
    &__10 {
      background: rgb(19, 218, 12);
      border-color: rgb(19, 218, 12);
    }
    &__20 {
      background: rgb(218, 215, 12);
      border-color: rgb(218, 215, 12);
    }
    &__30 {
      background: rgb(12, 15, 218);
      border-color: rgb(12, 15, 218);
    }
    &__40 {
      background: rgb(218, 12, 12);
      border-color: rgb(218, 12, 12);
    }
  }
}
.fc-button-group > .fc-button.fc-prev-button,
.fc-button-group > .fc-button.fc-next-button {
  padding: 0.25em 0.65em 0.55em;
  border-color: transparent;
}
.fc-today-button {
}
.fc-today-button:disabled {
  opacity: 0.2;
}
.tasks {
  &__filter {
    display: flex;
    align-items: center;
    .v-btn {
      height: auto !important;
      padding: 0 !important;
      .v-btn__content {
        padding: 3px 10px !important;
        font-size: 13px !important;
      }
    }
  }
}
</style>
